import {
    SET_FILTERED_AND_SORTED_INVOICES, IS_LOADING,
    SET_SELECTED_TYPE, SET_SELECTED_STATE, SET_START_DATE, SET_END_DATE,
    SET_MIN_AMOUNT, SET_MAX_AMOUNT, SET_NUMBER_INPUT, NB_MAX_INVOICES_TO_DISPLAY,
    SET_TOTAL_UNTAXED_AMOUNT, SET_TOTAL_AMOUNT, SET_DISPLAY_AS_LIST, OUT_REFUND, OUT_INVOICE
} from './invoicesConstants'
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { throwErrorMessage } from '../../lib/error_helper';
import { adaptInvoiceForMyOpen } from './invoicesCast';
import { setNbTotalResults } from '../contextInfos/contextInfosActions';
import { ALL_SELECT_OPTION } from '../../constants';
import { getSiteIds } from '../customerSite/customerSiteActions';
import { downloadFile, sortListOfTableBy } from '../../utils';
import { MODULE_EXTRANET_INVOICES } from '../authorizedApps/authorizedAppsConstants'
import moment from 'moment';

export function invoicesIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'invoices',
        isLoading: value
    };
}

export function setSelectedTypeAction(selectedType) {
    return {
        type: SET_SELECTED_TYPE,
        selectedType,
    }
}

export function setSelectedStateAction(selectedState) {
    return {
        type: SET_SELECTED_STATE,
        selectedState,
    }
}

export function setStartDateAction(startDate) {
    return {
        type: SET_START_DATE,
        startDate,
    }
}

export function setEndDateAction(endDate) {
    return {
        type: SET_END_DATE,
        endDate,
    }
}

export function setMinAmountAction(minAmount) {
    return {
        type: SET_MIN_AMOUNT,
        minAmount,
    }
}

export function setMaxAmountAction(maxAmount) {
    return {
        type: SET_MAX_AMOUNT,
        maxAmount,
    }
}

export function setNumberInputAction(numberInput) {
    return {
        type: SET_NUMBER_INPUT,
        numberInput,
    }
}

export function setFilteredAndSortedInvoicesAction(invoices) {
    return {
        type: SET_FILTERED_AND_SORTED_INVOICES,
        invoices,
    }
}

export function setTotalUntaxedAmountAction(totalUntaxedAmount) {
    return {
        type: SET_TOTAL_UNTAXED_AMOUNT,
        totalUntaxedAmount,
    }
}

export function setTotalAmountAction(totalAmount) {
    return {
        type: SET_TOTAL_AMOUNT,
        totalAmount,
    }
}

export function setDisplayAsListAction(displayAsList) {
    return {
        type: SET_DISPLAY_AS_LIST,
        displayAsList,
    }
}

export function loadInvoices(user, customerSiteId, allSites, invoicesFitlers, nbTotalResults) {
    return (dispatch) => {
        let tableState = {
            pageSize: NB_MAX_INVOICES_TO_DISPLAY,
            pageNumber: 0,
        }

        dispatch(setFilteredAndSortedInvoices(invoicesFitlers, null, null, tableState, user, customerSiteId, allSites, nbTotalResults))
    }
}

export function setFilteredAndSortedInvoices(invoicesFilters, affair, intervention, tableState, user, customerSiteId, allSites, nbTotalResults) {
    return (dispatch) => {

        if (!customerSiteId)
            return;

        dispatch(invoicesIsLoading(true));

        let customerSiteIds = getSiteIds(customerSiteId, allSites);

        let affairId = affair ? affair.id : null;

        if (intervention && intervention.affair_id)
            affairId = intervention.affair_id.id;

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/invoice/get_invoices_of_customer/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                customerSiteIds,
                userId: user.id,
                pageSize: tableState.pageSize,
                pageNumber: tableState.pageNumber,
                selectedState: invoicesFilters.selectedState === ALL_SELECT_OPTION ? null : invoicesFilters.selectedState,
                selectedType: invoicesFilters.selectedType === ALL_SELECT_OPTION ? null : invoicesFilters.selectedType,
                startDate: invoicesFilters.startDate ? invoicesFilters.startDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                endDate: invoicesFilters.endDate ? invoicesFilters.endDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                minAmount: invoicesFilters.minAmount,
                maxAmount: invoicesFilters.maxAmount,
                numberInput: invoicesFilters.numberInput,
                affairId,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(result => {
                let allInvoices = [];

                customerSiteIds.forEach(s => {
                    allInvoices = allInvoices.concat(result.invoices[s])
                })

                let transformedInvoices = allInvoices.map(i => adaptInvoiceForMyOpen(i));
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_INVOICES, result.nbTotalInvoices));
                transformedInvoices = sortListOfTableBy(tableState.orderBy, tableState.descOrder, transformedInvoices);
                dispatch(setTotalUntaxedAmountAction(calculateTotalAmount(transformedInvoices, "amount_untaxed")))
                dispatch(setTotalAmountAction(calculateTotalAmount(transformedInvoices, "amount_total")))
                dispatch(applyFiltersAndSortInvoices(invoicesFilters, transformedInvoices));
            }).catch((err) => {
                console.error("Erreur : invoiceActions - setFilteredAndSortedInvoices", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des factures !",
                }))
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_INVOICES, 0));
                dispatch(setTotalUntaxedAmountAction(0));
                dispatch(setTotalAmountAction(0));
                dispatch(invoicesIsLoading(false));
            });
    }
}

function calculateTotalAmount(invoices, amountField) {
    return invoices.reduce((sum, currentInvoice) => {
        let currentAmount = currentInvoice[amountField];

        if (currentInvoice.type === OUT_REFUND)
            return sum - currentAmount;
        else if (currentInvoice.type === OUT_INVOICE)
            return sum + currentAmount;
        else
            throw new Error("Type de facture non implémenté");
    }, 0)
}

function applyFiltersAndSortInvoices(invoicesFilters, invoices) {
    return (dispatch) => {
        let filteredInvoices = filter(invoices);
        let sortedAndFilteredInvoices = sort(filteredInvoices);
        dispatch(setFilteredAndSortedInvoicesAction(sortedAndFilteredInvoices));
        dispatch(invoicesIsLoading(false));
    }
}

export function sort(invoices) {
    return invoices;
}

export function filter(invoices) {
    let filteredInvoices = invoices.filter(() => {
        return true;
    });

    return filteredInvoices;
}

export function setSelectedType(value) {
    return (dispatch) => {
        dispatch(setSelectedTypeAction(value));
    }
}

export function setSelectedState(value) {
    return (dispatch) => {
        dispatch(setSelectedStateAction(value));
    }
}

export function setStartDate(value) {
    return (dispatch) => {
        dispatch(setStartDateAction(value));
    }
}

export function setEndDate(value) {
    return (dispatch) => {
        dispatch(setEndDateAction(value));
    }
}

export function setMinAmount(value) {
    return (dispatch) => {
        dispatch(setMinAmountAction(value));
    }
}

export function setMaxAmount(value) {
    return (dispatch) => {
        dispatch(setMaxAmountAction(value));
    }
}

export function setNumberInput(value) {
    return (dispatch) => {
        dispatch(setNumberInputAction(value));
    }
}

export function setDisplayAsList(value) {
    return (dispatch) => {
        dispatch(setDisplayAsListAction(value));
    }
}

export function getStates() {
    return [
        'open',
        'paid',
    ];
}

export function getTypes() {
    return [
        OUT_INVOICE,
        OUT_REFUND,
    ];
}

export function downloadInvoice(invoice, user) {
    return (dispatch) => {
        dispatch(invoicesIsLoading(true));
        const headers = new Headers({ 'Content-Type': 'application/json' });

        fetchWithTimeout("/api/v1/invoice/download_invoice", {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                userId: user.id,
                invoiceId: invoice.id,
                invoiceNumber: invoice.number,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(result => {
                if (result.length <= 0 || !result[0].datas) {
                    console.error("La facture est introuvable")
                    dispatch(invoicesIsLoading(false));
                    return;
                }

                let file = result[0];

                var dataURI = "data:application/pdf;base64," + file.datas;
                downloadFile(dataURI, file.datas_fname ? file.datas_fname : "Facture");
                dispatch(invoicesIsLoading(false));
            }).catch((err) => {
                console.error("Erreur : invoiceActions - downloadInvoice", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors du téléchargement de la facture !",
                }))
                dispatch(invoicesIsLoading(false));
            });
    }
}

export function invoiceIsDue(invoice){
    return invoice.type === "out_invoice" && invoice.date_due < moment() && invoice.state === "open";
}
